
import { BaseService } from "./base.service"; 

import {ServiceResult} from '../models/ServiceResult';
import {Company} from '../models/Company';
import {UserStatus} from '../models/UserStatus';
import {RegisterModel} from '../models/RegisterModel';
import {SendOtpRequest} from '../models/SendOtpRequest';
import {VerifyModel} from '../models/VerifyModel';

export class AuthApiService extends BaseService {
    constructor(auth?) { 
        super(auth);
    } 

    public updateUserDetails(request: RegisterModel) : Promise<ServiceResult<boolean>> {
        var url=`/api/auth/update-user-details`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public sendOtp(request: SendOtpRequest) : Promise<ServiceResult<string>> {
        var url=`/api/auth/send-otp`;
        return fetch(url,this.getOptions('post',request,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public registerContractor(request: RegisterModel) : Promise<ServiceResult<string>> {
        var url=`/api/auth/register-contractor`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public registerOther(request: RegisterModel) : Promise<ServiceResult<string>> {
        var url=`/api/auth/register-other`;
        return fetch(url,this.getOptions('post',request,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public verifyOtp(request: VerifyModel) : Promise<ServiceResult<string>> {
        var url=`/api/auth/verifyotp`;
        return fetch(url,this.getOptions('post',request,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public getUserCompanies() : Promise<ServiceResult<Company[]>> {
        var url=`/api/auth/get-user-companies`;
        return fetch(url,this.getOptions('get',null,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public addUserCompany(companyCode: string) : Promise<ServiceResult<boolean>> {
        var url=`/api/auth/add-user-company?companyCode=${encodeURIComponent(companyCode)}`;
        return fetch(url,this.getOptions('post',null,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public removeUserCompany(companyCode: string) : Promise<ServiceResult<boolean>> {
        var url=`/api/auth/remove-user-company?companyCode=${encodeURIComponent(companyCode)}`;
        return fetch(url,this.getOptions('post',null,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public checkUserStatus() : Promise<ServiceResult<UserStatus>> {
        var url=`/api/auth/checkUserStatus`;
        return fetch(url,this.getOptions('get',null,true,true))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public getVersion() : Promise<string> {
        var url=`/api/auth/getVersion`;
        return fetch(url,this.getOptions('get',null,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };

    public getHeaderFooterImages() : Promise<string[]> {
        var url=`/api/auth/getHeaderFooterImages`;
        return fetch(url,this.getOptions('get',null,true,false))
            .catch((e)=>{return this.fetchFailed(e,url);})
            .then(this.processResponse); 
        };
} 



// WEBPACK FOOTER //
// ./services/authapi.service.ts